import React from 'react';
import SEO from '../components/SEO';
import ServiceLayout from '../components/ServiceLayout';

const InstallationPage: React.FC = () => {
  return (
    <>
      <SEO
        title="Medical Equipment Installation Services"
        description="Certified installation of ceiling-mounted arms, patient monitors, mobile carts, workstations, and hospital room configurations nationwide."
        keywords="medical equipment installation, ceiling mounted arm installation, hospital room setup, patient monitor mounting, mobile cart installation, clinical workstation install"
        url="https://www.jvphealthtechsolutions.com/services/installation"
        structuredData={{
          "@context": "https://schema.org",
          "@type": "Service",
          "name": "Medical Equipment Installation",
          "description": "Certified installation of ceiling-mounted arms, patient monitors, mobile carts, workstations, and complete hospital room configurations.",
          "provider": { "@type": "Organization", "name": "JVP Health Tech Solutions" },
          "areaServed": "US"
        }}
      />
      <ServiceLayout
        title="Equipment Installation"
        subtitle="Professional installation for arms, carts, workstations, and complete room configurations."
        pageImage="/images/services/install-5a9cfb47.jpg"
        pageImageAlt="Equipment installation in hospital room"
        ctaText="Schedule Installation"
        summary="Our technicians handle everything — from ceiling-mounted arms and patient monitors to full department buildouts with dozens of rooms. Every install is clean, code-compliant, and done with minimal disruption to your staff and patients."
        sections={[
          {
            title: 'What We Install',
            body: 'We work with all major healthcare equipment manufacturers and handle installations of every size and complexity.',
            items: [
              'Ceiling and wall-mounted articulating arms',
              'Patient monitor mounts — bedside, wall, boom, and roller stand',
              'Fixed and height-adjustable workstations',
              'Mobile workstation carts with power management',
              'Virtual nursing stations with camera and display integration',
              'Pharmacy workstations, dispensing carts, and hood setups',
              'Track-mounted systems and custom room configurations',
              'Dual monitor and multi-display configurations',
            ],
          },
          {
            title: 'Our Process',
            body: 'Every installation follows the same proven steps — whether it\'s a single room or a coast-to-coast rollout.',
            items: [
              'Pre-install verification against the project plan — no assumptions',
              'Structural prep — backing, blocking, and infrastructure coordination',
              'Equipment mounting, cable routing, and integration',
              'Functional testing and ergonomic adjustment with your team',
              'Cleanup, documentation, and handoff — ready for patient care',
            ],
          },
          {
            title: 'Compliance & Standards',
            body: 'Every installation meets ADA accessibility requirements and Joint Commission standards — so your facility is inspection-ready the day we leave.',
            items: [
              'Mounting heights verified against ADA reach range requirements',
              'Clearances checked for wheelchair accessibility',
              'Equipment positioning optimized for clinical workflow',
              'Full documentation provided for compliance records',
            ],
          },
        ]}
      />
    </>
  );
};

export default InstallationPage;
